import CheckEmail from "./check-email";

export default CheckEmail;